import DeleteConfirmation from "components/modal/delete-confirmation"

export default {
  DeleteConfirmation
}
